import { render, staticRenderFns } from "./ImportedProvider.vue?vue&type=template&id=3b7340e6&"
import script from "./ImportedProvider.vue?vue&type=script&lang=js&"
export * from "./ImportedProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports